module.exports = __webpack_public_path__ + "img/logo4.a02f823b.webp";